import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Box } from '@mui/material';

// Register necessary components for Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BarChart = ({ data }) => {
  // Prepare the data for the bar chart
  const chartData = {
    labels: data.map(item => item.day),  // Extract day for x-axis
    datasets: [
      {
        label: 'Bookings',
        data: data.map(item => item.bookings),  // Extract bookings for y-axis
        backgroundColor: '#36A2EB',  // Set the color of the bars
        borderColor: '#36A2EB',
        borderWidth: 1,
      },
    ],
  };

  // Chart options
  const options = {
    responsive: true,
    scales: {
      x: {
        title: {
          display: true,
          text: 'Day of the Week',
        },
      },
      y: {
        title: {
          display: true,
          text: 'Bookings',
        },
        beginAtZero: true,  // Start y-axis from 0
      },
    },
    plugins: {
      legend: {
        display: false,  // Disable the legend
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            return `Bookings: ${tooltipItem.raw}`;  // Custom tooltip formatting
          },
        },
      },
    },
  };
  

  return (
    <Box m="5px">
      <Box height="300px" width="100%">
        <Bar data={chartData} options={options} />
      </Box>
    </Box>
  );
};

export default BarChart;
